import { render, staticRenderFns } from "./SwIconButton.vue?vue&type=template&id=2bf17f9f"
import script from "./SwIconButton.vue?vue&type=script&lang=js"
export * from "./SwIconButton.vue?vue&type=script&lang=js"
import style0 from "./SwIconButton.vue?vue&type=style&index=0&id=2bf17f9f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports